// Ignore responses for older filters, and clear old results when a refresh fails.
export async function loadLatestPerformance(state, request) {
  state.requestVersion += 1;
  const version = state.requestVersion;
  state.loading = true;
  state.error = false;
  state.report = null;
  try {
    const report = await request();
    if (version === state.requestVersion) state.report = report;
  } catch {
    if (version === state.requestVersion) state.error = true;
  } finally {
    if (version === state.requestVersion) state.loading = false;
  }
}
